import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import sanitize from 'angular-sanitize';

import depositComponent from './deposit.component';
import ecopayzFormComponent from './component/form/ecopayz/ecopayzform.component';
import skrillFormComponent from './component/form/skrill/skrillform.component';
import netellerFormComponent from './component/form/neteller/netellerform.component';
import bankFormComponent from './component/form/bank/bankform.component';
import bitcoinFormComponent from './component/form/bitcoin/bitcoinform.component';
import successModalComponent from './component/success.modal.component';
import netellerModalComponent from './component/neteller.modal.component';
import bankModalComponent from './component/bank.modal.component';
import skrillModalComponent from './component/skrill.modal.component';

import successPageComponent from './component/ecopayz/success.page.js';
import failurePageComponent from './component/ecopayz/failure.page.js';
import cancellationPageComponent from './component/ecopayz/cancellation.page.js';

import DepositStore from './service/deposit.store';

let depositModule = angular.module('deposit', [
  uiRouter,
  sanitize
])

.config(($stateProvider, $urlRouterProvider) => {
  'ngInject';

  $stateProvider
  .state('deposit', {
    parent: 'standardLayout',
    url: '/transactions/deposit',
    component: 'deposit',
    resolve: {
      authenticate: (SecurityService) => {
        SecurityService.authenticate();
      }
    }
  })
  .state('success', {
    parent: 'standardLayout',
    url: '/deposit/success',
    component: 'successPageComponent',
    resolve: {
      authenticate: (SecurityService) => {
        SecurityService.authenticate();
      }
    }
  })
  .state('failure', {
    parent: 'standardLayout',
    url: '/deposit/failure',
    component: 'failurePageComponent',
    resolve: {
      authenticate: (SecurityService) => {
        SecurityService.authenticate();
      }
    }
  })
  .state('cancel', {
    parent: 'standardLayout',
    url: '/deposit/cancel',
    component: 'cancellationPageComponent',
    resolve: {
      authenticate: (SecurityService) => {
        SecurityService.authenticate();
      }
    }
  })
  ;
})
.component('deposit', depositComponent)
.component('ecopayzForm', ecopayzFormComponent)
.component('skrillForm', skrillFormComponent)
.component('netellerForm', netellerFormComponent)
.component('bankForm', bankFormComponent)
.component('bitcoinForm', bitcoinFormComponent)
.component('depositSuccessModal', successModalComponent)
.component('netellerModal', netellerModalComponent)
.component('bankModal', bankModalComponent)
.component('skrillModal', skrillModalComponent)
.component('successPageComponent', successPageComponent)
.component('failurePageComponent', failurePageComponent)
.component('cancellationPageComponent', cancellationPageComponent)
.service('DepositStore', DepositStore)
.name;

export default depositModule;



// WEBPACK FOOTER //
// ./client/app/pages/customer/deposit/deposit.js